import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <header className="max-w-3xl mx-auto w-full px-4 sm:px-6 h-16 flex items-center">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5"
          data-testid="privacy-logo"
        >
          <Logo size={32} />
          <span className="font-heading font-black tracking-tight text-lg">Fairway Lab</span>
        </button>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 leading-relaxed text-slate-700">
        <h1 className="h-display text-3xl sm:text-4xl mb-2">Privacy Policy</h1>
        <p className="text-sm text-slate-500 mb-8">Effective Date: July 19, 2026</p>

        <p className="mb-6">
          Fairway Lab ("we," "our," or "us") respects your privacy. This Privacy Policy explains
          what information we collect, how we use it, and the choices you have when using the
          Fairway Lab mobile application and website.
        </p>

        <Section title="Information We Collect">
          <p>When you use Fairway Lab, we may collect:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>Name (if you choose to share it)</li>
            <li>Email Address</li>
            <li>User ID</li>
            <li>Practice sessions, reflections, notes, and other content you create</li>
            <li>
              Product interaction data, such as the number of practice sessions generated and app
              usage analytics to improve the app.
            </li>
          </ul>
        </Section>

        <Section title="How We Use Your Information">
          <p>We use your information to:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>Create and manage your account.</li>
            <li>Provide personalized golf practice sessions.</li>
            <li>Save your progress and practice history.</li>
            <li>Improve the app through analytics.</li>
            <li>Respond to support requests.</li>
            <li>Maintain the security and reliability of our services.</li>
          </ul>
        </Section>

        <Section title="Sign in with Apple">
          <p>
            If you choose Sign in with Apple, Apple may provide your name (if shared) and either
            your email address or a private relay email address. We use this information only to
            create and manage your Fairway Lab account.
          </p>
        </Section>

        <Section title="Analytics">
          <p>
            We collect limited analytics to understand how Fairway Lab is used, including
            information such as the number of sessions generated and feature usage. This helps us
            improve the app and user experience.
          </p>
        </Section>

        <Section title="Sharing of Information">
          <p>We do not sell your personal information.</p>
          <p className="mt-2">
            We may share information only with trusted service providers that help operate Fairway
            Lab (such as cloud hosting or authentication providers), or when required by law.
          </p>
        </Section>

        <Section title="Data Security">
          <p>
            We use reasonable administrative and technical safeguards to help protect your
            information. However, no method of electronic storage or transmission over the internet
            is completely secure.
          </p>
        </Section>

        <Section title="Children's Privacy">
          <p>
            Fairway Lab is not intended for children under 13 years of age. We do not knowingly
            collect personal information from children under 13.
          </p>
        </Section>

        <Section title="Your Choices">
          <p>
            You may request deletion of your account or personal data by contacting us at the email
            address below.
          </p>
        </Section>

        <Section title="Contact">
          <p>If you have questions about this Privacy Policy, contact us at:</p>
          <p className="mt-2">
            Email:{" "}
            <a
              href="mailto:fairwaylabgolf@gmail.com"
              className="text-[#0B2545] font-semibold underline"
              data-testid="privacy-contact-email"
            >
              fairwaylabgolf@gmail.com
            </a>
          </p>
        </Section>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-heading font-black text-[#0B2545] mb-2">{title}</h2>
      {children}
    </section>
  );
}
